if (window.jQuery) {

    (function ($) {

        $('#footer #tagline').each(function (i) {
            //if ($(this).isInTheMiddle()) {
            if (isInTheMiddle($(this))) {
                $(this).animate({opacity: 1}, 1000);
            }
        });

        $('#footer #newsletter').each(function (i) {
            //if ($(this).isInTheMiddle()) {
            if (isInTheMiddle($(this))) {
                $(this).animate({opacity: 1}, 1000);
            }
        });

        $(window).scroll(function (e) {

            $('#footer #tagline').each(function (i) {
                //if ($(this).isInTheMiddle()) {
                if (isInTheMiddle($(this))) {
                    $(this).animate({opacity: 1}, 1000);
                }
            });

            $('#footer #newsletter').each(function (i) {
                //if ($(this).isInTheMiddle()) {
                if (isInTheMiddle($(this))) {
                    $(this).animate({opacity: 1}, 1000);
                }
            });
        });


    })(jQuery);

}